<div class="notification-switch-track" [ngClass]="{ 'active-track': isActive }">
    <div class="notification-switch-knob" [ngClass]="{'active-knob': isActive }"></div>
</div>
